
import createIconComponent from '../utils/createIconComponent';
import { SVG_CLOSE_FILLED } from '../../../dist';
import React from 'react';
const CloseFilledIcon = createIconComponent({ content: SVG_CLOSE_FILLED, height: 24, width: 24 });
CloseFilledIcon.displayName = 'CloseFilledIcon';
export default CloseFilledIcon;
